import Jt808SengcmdDetailModal from './jt808-sendcmd-detail-modal.vue'
export default Jt808SengcmdDetailModal
